module.exports = __webpack_public_path__ + "img/690.fe552d6b.jpg";